<template>
  <UnicryptV4Reserve2></UnicryptV4Reserve2>
</template>

<script>
import UnicryptV4Reserve2 from "@/components/UnicryptV4Reserve2.vue";

export default {
  name: "UnicryptV4Reserve2View",
  components: {
    UnicryptV4Reserve2,
  },
};
</script>
